<div class="course-participants">
  <h2 [class]="'heading' | translate" translate>Organizer</h2>
  <div class="rows-columns mt-20">
    <div class="flex-row-between-center">
      <div class="flex-row-start-center">
        <div class="course-participants__wrapper background-loading-tiny">
          <img [appFetchProfileImage]="organizer.memberId" alt="" lazy="true" loading="lazy" src="assets/images/placeholder.png" />
        </div>
        <div class="ml-10">
          <h4 class="course-participants__name">{{ organizer.fullName }}</h4>
          <!--          <p class="course-participants__role" translate>Group Admin</p>-->
          <p class="course-participants__role" translate>{{ organizer.email }}</p>
          <!--          <p *ngIf="false" class="tag" translate>New Member</p>-->
        </div>
      </div>
      <!--      <div>-->
      <!--        <app-badge [text]="'Approved' | translate" [type]="'success'" fontSize="10px"></app-badge>-->
      <!--      </div>-->
    </div>
  </div>

  @if ((approvedParticipants && approvedParticipants.length) || (unapprovedParticipants && unapprovedParticipants.length)) {
    <h2 class="heading mt-30" translate>Participants</h2>
  }

  <!-- Approved Users -->
  <div class="rows-columns mt-20">
    @for (participant of approvedParticipants; track participant.users.memberId) {
      <div class="flex-row-between-center">
        <div class="flex-row-start-center">
          <div class="course-participants__wrapper background-loading-tiny">
            <img [appFetchProfileImage]="participant.users?.memberId" alt="" lazy="true" loading="lazy" src="assets/images/placeholder.png" />
          </div>
          <div class="ml-10">
            <h4 class="course-participants__name">{{ participant.users?.fullName || participant?.users?.firstname + ' ' + participant?.users?.lastname }}</h4>
            <p class="course-participants__role" translate>{{ participant.users?.email }}</p>
            <!--            <p class="course-participants__role" translate>Group Admin</p>-->
            <!--              <p *ngIf="false" class="tag" translate>New Member</p>-->
          </div>
        </div>
        <div>
          <app-badge [text]="getApprovedText(participant) | translate" [type]="getBadgeColor(participant)" fontSize="10px"></app-badge>
        </div>
      </div>
    }
  </div>

  <!-- Unapproved Users -->
  <div class="rows-columns mt-20">
    @for (user of unapprovedParticipants; track user.memberId) {
      <div class="flex-row-between-center">
        <div class="flex-row-start-center">
          <div class="course-participants__wrapper background-loading-tiny">
            <img [appFetchProfileImage]="user.memberId" alt="" lazy="true" loading="lazy" src="assets/images/placeholder.png" />
          </div>
          <div class="ml-10">
            <h4 class="course-participants__name">{{ user.fullName || user?.firstName + ' ' + user?.lastName }}</h4>
            <p class="course-participants__role" translate>{{ user.email }}</p>
            <!--            <p class="course-participants__role" translate>Group Admin</p>-->
            <!--            <p *ngIf="false" class="tag" translate>New Member</p>-->
          </div>
        </div>
        <div>
          <app-badge [text]="'Pending' | translate" [type]="'info'" fontSize="10px"></app-badge>
        </div>
      </div>
    }
  </div>
</div>
